// Configure Zone.js before it loads to prevent conflicts with Firebase polyfills and other libraries
// This prevents Zone.js from patching Promise to avoid conflicts with Firebase's promise-polyfill

// Disable Promise patching completely to avoid conflicts
(window as any).__Zone_disable_Promise = true;

// Alternative: Keep Promise patching but exclude specific libraries
// (window as any).__zone_symbol__UNPATCHED_EVENTS = ['Promise'];

// Disable RequestAnimationFrame patching if there are performance issues
// (window as any).__Zone_disable_requestAnimationFrame = true;

// Store original Promise before any modifications
(window as any).__zone_symbol__originalPromise = Promise;
